"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillLanguagePanelCms = void 0;
var BillLanguagePanelCms = /** @class */ (function () {
    function BillLanguagePanelCms() {
        this.sectionTitleLabel = 'Bill language';
        this.englishTextLabel = 'English';
        this.spanishTextLabel = 'Spanish';
    }
    return BillLanguagePanelCms;
}());
exports.BillLanguagePanelCms = BillLanguagePanelCms;
//# sourceMappingURL=BillLanguagePanelCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/BillLanguagePanel/BillLanguagePanelCms.cms.js
// module id = 2037
// module chunks = 8